import { useTranslation } from 'react-i18next';
import { AuthContainer } from '../features/DatevAuthStatus/AuthContainer';
import { Body, Heading } from '@e2n/ui/v2';
import { MitarbeiterAbgleichCard } from '../components/MitarbeiterAbgleich/MitarbeiterAbgleichCard';
import { useDatevAuthContext } from '../lib/DatevAuthContext';

export function Layout() {
  const { t } = useTranslation();
  const { status } = useDatevAuthContext();
  const isAuthorized = !!status?.authorized;

  return (
    <div className="p-4 md:p-10 h-full bg-neutrals-v2-200">
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-3">
          <Heading size={'lg'}>{t('domain.datev.page.title')}</Heading>
          <Body>{t('domain.datev.page.description')}</Body>
        </div>
        <AuthContainer />
        {isAuthorized && <MitarbeiterAbgleichCard />}
      </div>
    </div>
  );
}
